import { getNextPlayerId, isActiveGamePlayer } from '../../base/GamePlayer.js';
import { CmdResultTypes } from '../../shared/index.js';
import { isReadyForCommand, isPlayersTurn, getSumOfBids } from '../state/round.js';
import { isInProgress, OhHellRulesMessage, OhHellCmdType, bidPlacedEvent, biddingCompleteEvent, ohSucceed, ohFail, } from '../state/state.js';
import { initTrick } from '../state/trick.js';
export function placeBid(state, bid) {
    if (!isInProgress(state)) {
        return ohFail(OhHellRulesMessage.NotBidPhase);
    }
    const bidFailure = checkForFailure(state, bid);
    if (bidFailure) {
        return bidFailure;
    }
    const currentRound = state.currentRound;
    const placedBid = { ...bid, wonTricks: 0 };
    const round = {
        ...currentRound,
        turnPlayerId: getNextPlayerId(bid.playerId, state.currentRound.players),
        bids: [...currentRound.bids, placedBid],
    };
    const bidState = { ...state, currentRound: round };
    const events = [bidPlacedEvent(bidState)];
    if (!isBiddingComplete(round)) {
        return ohSucceed(bidState, events);
    }
    const bidCompleteState = {
        ...bidState,
        currentRound: {
            ...bidState.currentRound,
            readyForCommands: [OhHellCmdType.PlayCard],
            currentTrick: initTrick(),
        },
    };
    events.push(biddingCompleteEvent({ ...state, currentRound: round }));
    return ohSucceed(bidCompleteState, events);
}
function checkForFailure(state, bid) {
    const currentRound = state.currentRound;
    return (ensureIsReadyForCommand(currentRound) ||
        ensureIsPlayersTurn(currentRound, bid) ||
        ensureDealerGetsScrewed(currentRound, bid) ||
        false);
}
function ensureDealerGetsScrewed(round, bid) {
    if (bid.playerId === round.dealerPlayerId) {
        const sumOfBids = getSumOfBids([...round.bids, bid]);
        if (sumOfBids === round.numberOfCards) {
            return {
                result: CmdResultTypes.Failure,
                message: OhHellRulesMessage.DealerGetsScrewed,
            };
        }
    }
    return false;
}
function ensureIsReadyForCommand(round) {
    return (!isReadyForCommand(round, OhHellCmdType.PlaceBid) &&
        ohFail(OhHellRulesMessage.NotBidPhase));
}
function ensureIsPlayersTurn(round, bid) {
    return (!isPlayersTurn(round, bid.playerId) &&
        ohFail(OhHellRulesMessage.NotPlayersTurn));
}
function isBiddingComplete(round) {
    const activePlayers = round.players.filter(isActiveGamePlayer);
    return !!(round.bids.length === activePlayers.length);
}
//# sourceMappingURL=placeBid.js.map